import React from 'react';
import {SortableContainer, SortableElement} from 'react-sortable-hoc';
import WorkoutItem from 'features/work-out/components/workoutItem';

const SortableItem = SortableElement(({workout, clientId}) => {
  return(
    <li key={workout.id} className="nobull">
      <WorkoutItem
        title={workout.name}
        desc={`${workout.level} Phase ${workout.phase}`}
        LinkTo={`/clients/${clientId}/workouts/${workout.id}/logs/new`}
        handleDrage={true}
      />
    </li>
  );
});

const WorkoutList = SortableContainer(({workouts, clientId}) => {
  return (
    <ul className="workout-list">
      {workouts && workouts.map((workout, index) => {
          return (
            <SortableItem
              key={`item-${workout.id}`}
              index={index}
              workout={workout}
              clientId={clientId}
            />
          );
        })
      }
    </ul>
  );
});

export default WorkoutList;
